import { appendOfferQueryParams } from "./appendOfferQueryParams"

export type EditOfferQueryParams =
	| { newCarOrderId: string; porscheCode?: never; reportSale?: boolean }
	| { newCarOrderId?: never; porscheCode: string; reportSale?: boolean }
	| { newCarOrderId?: never; porscheCode?: never; reportSale: boolean }

export const buildEditOfferUrl = (offerId: string, query?: EditOfferQueryParams): string =>
	appendOfferQueryParams(`/offers/${offerId}/edit`, query)
